import React from "react";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomBodyContent = styled("div")(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}));
const UserLayout = (props) => {
  const { component } = props;
  return (
    <>
      <Grid container spacing={2} sx={{ minHeight: "100vh" }}>
        <Grid item xs={12}>
          <CustomBodyContent>{component}</CustomBodyContent>
        </Grid>
      </Grid>
    </>
  );
};

UserLayout.propTypes = {};

export default UserLayout;
